import {Routes, Route} from 'external/react' 
import GroupGrades from './Gradebook'
import GroupGradesContainer from './GradebookContainer'

export default function Gradebook() {
  return (
    <Routes>
      <Route element={<GroupGradesContainer />}>
        <Route path="/*" element={<GroupGrades />} />
      </Route>
    </Routes>
  )
}
